import React, { useState,useEffect } from "react";
import Header from '../../layout/header';
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import axios from 'axios'
import DropDownInput from "../../../component/Input/dropDownInput/dropDownInput";
import { toast } from "react-toastify";
import SuccessModal from "../../CustomModal/Success";
import *  as Constants from '../contants';
import ModalPop from '../../modal/modal';

const ReferralDetails = ({
    referralDetails=[],
    referralApproval=[],
    viewReferralDetails,
    updateReferralStatus,
    getAllReferrals,
    match,
    history
}) => {
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        remarks: '',
        rejection_reason_id:'',
        rejection_reason_name:'',
        extra:'',
        merged_with: '',
        merged_id: '',
        assigned_user_id: '',
    });
    const [status, setStatus] = useState('');
    const [userOptions, setUserOptions] = useState([]);
    const [leadOptions, setLeadOptions] = useState([]);
    const [accountOptions, setAccountOptions] = useState([]);
    const [userId, setUserId] = useState('');
    const [referralData,setReferralData]=useState();
    const [roleId, setRoleId] = useState('');
    const [isPm,setIsPm]=useState('');
    const [showApproveModal,setShowApproveModal]=useState(false);
    const [showHoldModal,setShowHoldModal]=useState(false);
    const [showRejectModal,setShowRejectModal]=useState(false);
    const [rejectionReasons,setRejectionReasons]=useState([]);

    
    useEffect(() => {
        setUserId(localStorage.getItem('user_id'));
        setRoleId(localStorage.getItem('role_id'));
        setIsPm(localStorage.getItem('is_pm'));
    }, []);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            const res = await viewReferralDetails(match.params.id);
            const { referral_details, users, leads, accounts,rejection_reasons } = res;
            setReferralData(referral_details);
            setFormData({
                remarks: referral_details?.remarks || '',
                merged_with: referral_details?.merged_with || '',
                merged_id: referral_details?.merged_id || '',
                assigned_user_id: referral_details?.assigned_user_id || '',
                rejection_reason_id:referral_details?.rejection_reason_id || '',
                rejection_reason_name:referral_details?.rejection_reason_name || '',
                extra:referral_details?.extra || '',
            });
            setStatus(referral_details?.status);
            setUserOptions(users);
            setLeadOptions(leads);
            setAccountOptions(accounts);
            setRejectionReasons(rejection_reasons)
            setIsLoading(false);     
        })();
    }, [viewReferralDetails, match.params.id]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleApproval = async () => {
        setIsLoading(true)
        const validateForm = () => {
            // Check for required fields
            if (!formData.assigned_user_id) {
                toast.error("Assigned User is required");
                return false;
            }
            if (!formData.merged_with) {
                toast.error("Referral Type is required");
                return false;
            }
            if (formData.type === 'lead' && !formData.merged_id) {
                toast.error("Lead ID is required");
                return false;
            }
            if (formData.type === 'account' && !formData.merged_id) {
                toast.error("Account ID is required");
                return false;
            }
            return true;
        };
    
        try {
            setIsLoading(true);
            if (!validateForm()) {
                setIsLoading(false);     
                return; // Stop execution if validation fails
            }
            const response = await updateReferralStatus(match.params.id, { ...formData, status: Constants.STATUS_ASSIGNED });
            if (response.status) {
                setShowApproveModal(false)
                setIsSuccessModalOpen(true)
                let filter = window.localStorage.referralFilter ? JSON.parse(window.localStorage.referralFilter) : [];
                // await getAllReferrals(1, {'referred_by_id':userId},filter);
            }else{
                const message=response?.response?.message
                if(message){
                    toast.error(response.response.message)
                }else{
                    toast.error("Something went wrong")
                }
            }
            setIsLoading(false);     

        } catch (error) {
            console.error("Error while approving referral:", error);
            setIsLoading(false);     
        }
    };

    const handleRejection = async () => {
        try {
            if (!formData.remarks) {
                toast.error("Remarks are required");
                return false;
            }
            if (!formData.rejection_reason_id) {
                toast.error("Rejection Reason are required");
                return false;
            }
            if (formData.rejection_reason_id==Constants?.REJECTION_REASON_LOSS_TO_COMP && !formData.extra) {
                toast.error("Competitor Name is required");
                return false;
            }
            if (formData.rejection_reason_id==Constants?.REJECTION_REASON_OTHERS && !formData.extra) {
                toast.error("Other Rejection Remarks are required");
                return false;
            }
            setIsLoading(true);
            const response = await updateReferralStatus(match.params.id, { ...formData,status: Constants.STATUS_REJECTED });
            if (response.status) {
                setShowRejectModal(false)
                setIsSuccessModalOpen(true)
                let filter = window.localStorage.referralFilter ? JSON.parse(window.localStorage.referralFilter) : [];
                // await getAllReferrals(1, {'referred_by_id':userId},filter);
            }
            setIsLoading(false);     
        } catch (error) {
            console.error("Error while rejecting referral:", error);
            setIsLoading(false);     
        }
    };

    const handleHold = async () => {
        try {
            if (!formData.remarks) {
                toast.error("Remarks are required");
                return false;
            }
            setIsLoading(true);
            const response = await updateReferralStatus(match.params.id, { ...formData,status: Constants.STATUS_ON_HOLD });
            if (response.status) {
                setShowHoldModal(false)
                setIsSuccessModalOpen(true)
                let filter = window.localStorage.referralFilter ? JSON.parse(window.localStorage.referralFilter) : [];
                // await getAllReferrals(1, {'referred_by_id':userId},filter);
            }
            setIsLoading(false);     
        } catch (error) {
            console.error("Error while rejecting referral:", error);
            setIsLoading(false);     
        }
    };

    const handleClose = async () => {
        try {
            setIsLoading(true);
            const response = await updateReferralStatus(match.params.id, { ...formData,status: Constants.STATUS_CLOSED });
            if (response.status) {
                setIsSuccessModalOpen(true)
            }
            setIsLoading(false);     
        } catch (error) {
            console.error("Error while clossing referral:", error);
            setIsLoading(false);     
        }
    };

    const handleOrderWon = async () => {
        try {
            setIsLoading(true);
            const response = await updateReferralStatus(match.params.id, { ...formData,status: Constants.STATUS_ORDER_WON });
            if (response.status) {
                setIsSuccessModalOpen(true)
            }
            setIsLoading(false);     
        } catch (error) {
            console.error("Error while Updating referral:", error);
            setIsLoading(false);     
        }
    };

    const handleOrderLost = async () => {
        try {
            if (!formData.remarks) {
                toast.error("Remarks are required");
                return false;
            }
            setIsLoading(true);
            const response = await updateReferralStatus(match.params.id, { ...formData,status: Constants.STATUS_ORDER_LOST });
            if (response.status) {
                setIsSuccessModalOpen(true)
            }
            setIsLoading(false);     
        } catch (error) {
            console.error("Error while Updating referral 2:", error);
            setIsLoading(false);     
        }
    };

    function closeModal() {
        setShowApproveModal(false);
        window.location.reload()
    }

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={'Status updated successfully'}
                url={'referrals-options'}
            />
            <ModalPop
                title="Fill the following details"
                show={showApproveModal}
                handleModalHide={closeModal}
                keyboard
                backdrop
            >
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="mb-4">
                                <label htmlFor="remarks" className="form-label">Remarks</label>
                                <textarea
                                    id="remarks"
                                    name="remarks"
                                    className="form-control"
                                    rows="3"
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="merged_with" className="form-label">Referral Type<span className="text-danger">*</span></label>
                                <select
                                    id="merged_with"
                                    name="merged_with"
                                    className="form-control"
                                    onChange={handleInputChange}
                                >
                                    <option value="">Select Type</option>
                                    <option value="lead">Lead</option>
                                    <option value="account">Account</option>
                                </select>
                            </div>

                            <div className="mb-4">
                                <label htmlFor="merged_id" className="form-label">
                                    {formData?.merged_with === 'lead' ? 'Lead ID' : 'Account ID'}
                                    <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="number"
                                    id="merged_id"
                                    name="merged_id"
                                    className="form-control"
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="assignedUser" className="form-label">Assign User<span className="text-danger">*</span></label>
                                <select
                                    id="assignedUser"
                                    name="assigned_user_id"
                                    className="form-control"
                                    onChange={handleInputChange}
                                    value={formData?.assigned_user_id || ''}
                                >
                                    <option value="">Choose...</option>
                                    {userOptions.map(option => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="text-center">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleApproval}
                                    style={{
                                        paddingLeft: '20px',
                                        paddingRight: '20px'
                                    }}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
            </ModalPop>
            <ModalPop
                title='Fill the following details'
                show={showRejectModal}
                handleModalHide={closeModal}
                keyboard
                backdrop
                // url={url}
            >
                <div className="row justify-content-center">
                        <div className="col-md-8">
                <div className="mb-4">
                        <label htmlFor="rejection_reason_id" className="form-label">
                            Rejection Reason
                            <span className="text-danger">*</span>
                        </label>
                        <select
                            className="form-control"
                            id="rejection_reason_id"
                            name="rejection_reason_id"
                            onChange={handleInputChange}
                            required
                        >
                            <option value="">Choose...</option>
                            {Object.entries(rejectionReasons).map(([id, name]) => (
                                <option key={id} value={id}>
                                    {name}
                                </option>
                            ))}
                        </select>
                    </div>
                    {(formData?.rejection_reason_id === '5' || formData?.rejection_reason_id === '6') && (
                        <div className="mb-4">
                            <label htmlFor="extra" className="form-label">
                            {formData?.rejection_reason_id === '5' ? 'Competitor Name' : 'Other Remarks'}<span className="text-danger">*</span>
                            </label>
                            <textarea
                            id="extra"
                            name="extra"
                            className="form-control"
                            rows="3"
                            onChange={handleInputChange}
                            />
                        </div>
                    )}
                    <div className="mb-4">
                        <label htmlFor="remarks" className="form-label">Remarks<span className="text-danger">*</span></label>
                        <textarea
                            id="remarks"
                            name="remarks"
                            className="form-control"
                            rows="3"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="text-center">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleRejection}
                            style={{
                                paddingLeft: '20px',
                                paddingRight: '20px'
                            }}
                        >
                            Submit
                        </button>
                    </div>
                    </div>
                </div>
            </ModalPop>
            <ModalPop
                title='Fill the following details'
                show={showHoldModal}
                handleModalHide={closeModal}
                keyboard
                backdrop
                // url={url}
            >
                <div className="row justify-content-center">
                        <div className="col-md-8">
                <div className="mb-4">
                    <label htmlFor="remarks" className="form-label">Remarks<span className="text-danger">*</span></label>
                    <textarea
                        id="remarks"
                        name="remarks"
                        className="form-control"
                        rows="3"
                        onChange={handleInputChange}
                    />
                </div>
                <div className="text-center">
                    <button
                        type="button"
                        className="btn btn-primary me-3"
                        onClick={()=>{
                            if(status==Constants.STATUS_ASSIGNED){
                                handleOrderLost()
                            }else{
                                handleHold()
                            }
                        }}
                        style={{
                            paddingLeft: '20px',
                            paddingRight: '20px'
                        }}
                    >
                        Submit
                    </button>
                </div>
                </div>
                </div>
            </ModalPop>
            <Loader isLoading={isLoading} />
            <div id="wrapper">
                <DashboardMenu />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header title="Referral Details" />
                        <div className="container-fluid bg-light" style={{
                                                                            padding: '0.5rem'
                                                                        }}>
                            <h1 className="h3 mb-4 text-primary">Referral Details</h1>
                            <form className="bg-white p-2 rounded shadow-sm">
                                <div className="row mb-3">
                                    <div className="col-md-4">
                                        <label htmlFor="referred_by_name" className="form-label">Referred By Name</label>
                                        <input
                                            type="text"
                                            id="referred_by"
                                            name="referred_by"
                                            className="form-control"
                                            value={referralData?.referred_by_name || ''}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="referred_by_contact" className="form-label">Referred By Contact</label>
                                        <input
                                            type="text"
                                            id="contact"
                                            name="contact"
                                            className="form-control"
                                            value={referralData?.referred_by_contact || ''}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="referred_by_email" className="form-label">Referred By Mail</label>
                                        <input
                                            type="text"
                                            id="email"
                                            name="email"
                                            className="form-control"
                                            value={referralData?.referred_by_email || ''}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="referred_on" className="form-label">Referred On</label>
                                        <input
                                            type="date"
                                            id="referred_on"
                                            name="referred_on"
                                            className="form-control"
                                            value={referralData?.created_at ? new Date(referralData.created_at).toISOString().split('T')[0] : ''  || ''}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="clientName" className="form-label">Client Name</label>
                                        <input
                                            type="text"
                                            id="clientName"
                                            name="clientName"
                                            className="form-control"
                                            value={referralData?.client_name || ''}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="project_type" className="form-label">Project Type</label>
                                        <input
                                            type="text"
                                            id="project_type"
                                            name="project_type"
                                            className="form-control"
                                            value={referralData?.project_type || ''}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="team_name" className="form-label">Team</label>
                                        <input
                                            type="text"
                                            id="team_name"
                                            name="team_name"
                                            className="form-control"
                                            value={referralData?.team_name || ''}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="status" className="form-label">Status</label>
                                        <input
                                            type="text"
                                            id="status"
                                            name="status"
                                            className="form-control"
                                            value={referralData?.status_text}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <label htmlFor="clientLocation" className="form-label">Client Location</label>
                                        <input
                                            type="text"
                                            id="clientLocation"
                                            name="clientLocation"
                                            className="form-control"
                                            value={referralData?.client_location || ''}
                                            disabled
                                            style={{ width: '100%', height: '400px' }}
                                        />
                                    </div>
                                    <div className="card mb-4">
                                        <div className="card-header">
                                            <h5 className="card-title mb-0">SPOC Details</h5>
                                        </div>
                                        <div className="card-body">
                                            <div className="row mb-3">
                                                {referralData?.spoc_details && referralData.spoc_details.length > 0 ? (
                                                        referralData.spoc_details.map((spoc, index) => (
                                                            <React.Fragment key={index}>
                                                                <div className="col-md-4">
                                                                    <label htmlFor={`spocName-${index}`} className="form-label">SPOC Name {index + 1}</label>
                                                                    <input
                                                                        type="text"
                                                                        id={`spocName-${index}`}
                                                                        name={`spocName-${index}`}
                                                                        className="form-control"
                                                                        value={spoc.name || ''}
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <label htmlFor={`spocNumber-${index}`} className="form-label">SPOC Number {index + 1}</label>
                                                                    <input
                                                                        type="text"
                                                                        id={`spocNumber-${index}`}
                                                                        name={`spocNumber-${index}`}
                                                                        className="form-control"
                                                                        value={spoc.number || ''}
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <label htmlFor={`spocEmail-${index}`} className="form-label">SPOC Email {index + 1}</label>
                                                                    <input
                                                                        type="email"
                                                                        id={`spocEmail-${index}`}
                                                                        name={`spocEmail-${index}`}
                                                                        className="form-control"
                                                                        value={spoc.email || ''}
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <label htmlFor={`spocDesignation-${index}`} className="form-label">SPOC Designation {index + 1}</label>
                                                                    <input
                                                                        type="text"
                                                                        id={`spocDesignation-${index}`}
                                                                        name={`spocDesignation-${index}`}
                                                                        className="form-control"
                                                                        value={spoc.designation || ''}
                                                                        disabled
                                                                    />
                                                                </div>
                                                            </React.Fragment>
                                                        ))
                                                    ) : (
                                                        <div className="col-md-12">
                                                            <p>No SPOC details available.</p>
                                                        </div>
                                                    )}
                                                </div>
                                        </div>
                                    </div>
                                    <div className="card mb-4">
                                        <div className="card-header">
                                            <h5 className="card-title mb-0">Attachments</h5>
                                        </div>
                                        <div className="card-body">
                                            <div className="row mb-3">
                                            {referralData?.attachment && referralData.attachment.length > 0 ? (
                                                referralData.attachment.map((attach, index) => (
                                                <div className="col-md-4" key={index}>
                                                    <label htmlFor={`attachment-${index}`} className="form-label">Attachment {index + 1}</label>
                                                    <a
                                                    href={attach}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-outline-secondary d-block mb-2"
                                                    >
                                                    <i className="fas fa-paperclip"></i> View Attachment {index + 1}
                                                    </a>
                                                </div>
                                                ))
                                            ) : (
                                                <div className="col-md-12">
                                                <p>No Attachments available.</p>
                                                </div>
                                            )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-4 p-3 border rounded bg-light">
                                        <h5 className="mb-3 text-primary">Details of the Person who gave the Referral</h5>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Name <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id={`referral_giver_name`}
                                                    name={`referral_giver_name`}
                                                    className="form-control"
                                                    value={referralData?.referral_giver_name}
                                                    onChange={e => handleInputChange(null, e)}
                                                    placeholder="Enter Name"
                                                    disabled
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Phone Number
                                                </label>
                                                <input
                                                    type="text" 
                                                    id="referral_giver_number"
                                                    name="referral_giver_number"
                                                    className="form-control"
                                                    value={referralData?.referral_giver_number}
                                                    onChange={e => handleInputChange(null, e)}
                                                    placeholder="Enter Phone Number"
                                                    pattern="\d{10}"
                                                    title="Phone number must be 10 digits"
                                                    maxLength="10"
                                                    disabled
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Email
                                                </label>
                                                <input
                                                    type="email"
                                                    id={`referral_giver_email`}
                                                    name={`referral_giver_email`}
                                                    className="form-control"
                                                    value={referralData?.referral_giver_email}
                                                    onChange={e => handleInputChange(null, e)}
                                                    placeholder="Enter Email"
                                                    disabled
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Designation <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id={`referral_giver_designation`}
                                                    name={`referral_giver_designation`}
                                                    className="form-control"
                                                    value={referralData?.referral_giver_designation}
                                                    placeholder="Enter Designation"
                                                    required
                                                    disabled
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Site Name <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id={`referral_giver_site`}
                                                    name={`referral_giver_site`}
                                                    className="form-control"
                                                    value={referralData?.referral_giver_site}
                                                    required
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                
                                        {referralDetails &&
                                            referralDetails?.data &&
                                            referralDetails?.data?.activities &&
                                            referralDetails?.data?.activities?.length > 0 && (
                                                <>
                                                <hr/>
                                                <h5 className="card-title mb-3"  style={{display: 'flex',
                                                                                justifyContent: 'center',
                                                                                color: '#4e73df'}}>
                                                        Meeting details</h5>
                                                        <div className="row">
                                                        {referralDetails?.data?.activities.map((val, i) => (
                                                            <div key={i} className="col-lg-4 col-md-6 col-12">
                                                                <div className="card-big-shadow">
                                                                    <div
                                                                        className="card card-just-text p-3"
                                                                        style={{
                                                                            borderRadius: '10px',
                                                                            backgroundColor: '#f8f9fa',
                                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                                        }}
                                                                    >
                                                                        <div className="content" style={{ padding: 'initial' }}>
                                                                            <h6 className="category mrg-b-12">
                                                                                <div className="list-view" style={{ margin: 'auto' }}>
                                                                                    <div className="row mb-2 d-flex" style={{justifyContent:'space-between'}}>
                                                                                        <div>
                                                                                            <i className="bi bi-calendar-check text-info"></i>
                                                                                            &nbsp;<strong>Activity Date</strong>
                                                                                        </div>
                                                                                        <div
                                                                                            className="col-6 d-flex align-items-center">
                                                                                            <span>{val?.activity_date}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <hr style={{ borderTop: '1px solid #ddd', margin: '10px 0' }} />
                                                                                <div className="list-view" style={{ margin: 'auto' }}>
                                                                                    {[
                                                                                        {
                                                                                            label: 'Activity Type',
                                                                                            icon: 'bi-clipboard-check text-info',
                                                                                            value: val?.activity_type || 'N/A',
                                                                                        },
                                                                                        {
                                                                                            label: 'Sub Activity Type',
                                                                                            icon: 'bi-clipboard-data text-info', 
                                                                                            value: val?.sub_activity_type || 'N/A',
                                                                                        },
                                                                                        {
                                                                                            label: 'Meeting Done By',
                                                                                            icon: 'bi-person-circle text-primary', 
                                                                                            value: val?.assign_to || 'N/A',
                                                                                        },
                                                                                        {
                                                                                            label: 'Check In Date',
                                                                                            icon: 'bi-calendar-check text-success',
                                                                                            value: val?.check_in_date || 'N/A',
                                                                                        },
                                                                                        {
                                                                                            label: 'Check Out Date',
                                                                                            icon: 'bi-calendar-x text-danger', 
                                                                                            value: val?.check_out_date || 'N/A',
                                                                                        },
                                                                                        {
                                                                                            label: 'Meeting Duration',
                                                                                            icon: 'bi-clock-history text-success',
                                                                                            value: val?.time_difference || 'N/A',
                                                                                        },
                                                                                        {
                                                                                            label: 'MOM',
                                                                                            icon: 'bi-file-earmark-text text-warning',
                                                                                            value: val?.meta_data?.[0]?.MOM || 'N/A',
                                                                                        },
                                                                                    ].map((item, idx) => (
                                                                                        <div key={idx} className="row mb-2 d-flex" style={{justifyContent:'space-between'}}>
                                                                                            <div>
                                                                                                <i className={`bi ${item.icon}`}></i>
                                                                                                &nbsp;<strong>{item.label}</strong>
                                                                                            </div>
                                                                                            <div
                                                                                                className="col-6 d-flex align-items-center">
                                                                                                <span className="trigger" data-tooltip-id="1">
                                                                                                    {item.value}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </h6>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                </div>
                                            <hr/>
                                    </>
                                )}
                                { status != Constants.STATUS_PENDING && (
                                <div className="card mb-4">
                                        <div className="card-header">
                                            <h5 className="card-title mb-0">Last Action details</h5>
                                        </div>
                                        <div className="card-body">
                                            <div className="row mb-3">
                                                <div className="col-md-4">
                                                    <label className="form-label">
                                                        Current Status
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id={`current_status`}
                                                        name={`current_status`}
                                                        className="form-control"
                                                        value={Constants?.referalFilterArray.find(ref => ref?.id == referralData?.status)?.name}
                                                        disabled={true}
                                                    />
                                                </div>
                                                {referralData?.rejection_reason_name &&
                                                    <div className="col-md-4">
                                                        <label htmlFor="team_id" className="form-label">
                                                            Rejection Reason
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id={`rejection_reason`}
                                                            name={`rejection_reason`}
                                                            className="form-control"
                                                            value={referralData?.rejection_reason_name||''}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                }
                                                {referralData?.remarks &&
                                                    <div className="col-md-4">
                                                        <label htmlFor="remarks" className="form-label">Remarks</label>
                                                        <textarea
                                                            id="remarks"
                                                            name="remarks"
                                                            className="form-control"
                                                            rows="3"
                                                            value={referralData?.remarks || ''}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                }
                                                {referralData?.extra &&
                                                    <div className="col-md-4">
                                                        <label htmlFor="extra" className="form-label">
                                                            {referralData?.rejection_reason_id == '5' ? 
                                                                'Competitor Name' : 
                                                                'Other Remarks'
                                                            }<span className="text-danger">*</span>
                                                        </label>
                                                        <textarea
                                                            id="extra"
                                                            name="extra"
                                                            className="form-control"
                                                            rows="3"
                                                            value={referralData?.extra || ''}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                }
                                                {referralData?.merged_with && referralData?.merged_id &&(
                                                    <>
                                                    <div className="col-md-4">
                                                        <label htmlFor="merged_with" className="form-label">Referral Type</label>
                                                        <select
                                                            id="merged_with"
                                                            name="merged_with"
                                                            className="form-control"
                                                            onChange={handleInputChange}
                                                            value={referralData?.merged_with || ''}
                                                            disabled={true}
                                                        >
                                                            <option value="">Select Type</option>
                                                            <option value="lead">Lead</option>
                                                            <option value="account">Account</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label htmlFor="merged_id" className="form-label">
                                                            {referralData?.merged_with == 'lead' ? 'Lead ID' : 'Account ID'}
                                                        </label>
                                                        <input
                                                            type="number"
                                                            id="merged_id"
                                                            name="merged_id"
                                                            className="form-control"
                                                            onChange={handleInputChange}
                                                            value={referralData?.merged_id || ''}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    </>
                                                )}
                                                {referralData?.assigned_user_name &&
                                                    <div className="col-md-4">
                                                        <label htmlFor="assignedUser" className="form-label">Assigned User</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={referralData?.assigned_user_name || 'NA'}
                                                            disabled
                                                        />
                                                    </div>
                                                }
                                                {referralData?.action_taken_by_name && 
                                                    <div className="col-md-4">
                                                        <label htmlFor="actionTakenByUser" className="form-label">Last Action Taken By</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={referralData?.action_taken_by_name || 'NA'}
                                                            disabled
                                                        />
                                                    </div>
                                                }
                                            </div>
                                   
                                    </div>
                                </div>
                                )}
                                <div className="d-flex justify-content-center">
                                {isPm === 'true' && status == Constants.STATUS_PENDING && (
                                    <div className="d-flex justify-content-end mb-3">
                                        <button
                                            type="button"
                                            className="btn btn-success me-3"
                                            style={{ marginRight: '2rem' }}
                                            onClick={()=>{
                                                setIsLoading(true)
                                                setShowApproveModal(true)
                                                setIsLoading(false)
                                            }}
                                        >
                                            Approve
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-primary me-3"
                                            onClick={()=>{
                                                setIsLoading(true)
                                                setShowHoldModal(true)
                                                setIsLoading(false)
                                            }}
                                            style={{
                                                paddingLeft: '20px',
                                                paddingRight: '20px'
                                            }}
                                        >
                                            Hold
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            style={{ marginLeft: '2rem' }}
                                            onClick={()=>{
                                                setIsLoading(true)
                                                setShowRejectModal(true)
                                                setIsLoading(false)
                                            }}
                                        >
                                            Reject
                                        </button>
                                    </div>
                                  )}
                                  {(isPm === 'true' && status == Constants.STATUS_ASSIGNED) && (
                                    <div className="d-flex justify-content-end mb-3">
                                        <button
                                            type="button"
                                            className="btn btn-success me-3"
                                            style={{ marginRight: '2rem' }}
                                            onClick={handleOrderWon}
                                        >
                                            Order Won
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            style={{ marginLeft: '2rem' }}
                                            onClick={()=>{
                                                setIsLoading(true)
                                                setShowHoldModal(true)
                                                setIsLoading(false)
                                            }}
                                        >
                                            Order Lost
                                        </button>
                                    </div>
                                  )}
                                  {(isPm === 'true' && status == Constants.STATUS_ON_HOLD) && (
                                        <div className="d-flex justify-content-end mb-3">
                                        <button
                                            type="button"
                                            className="btn btn-success me-3"
                                            style={{ marginRight: '2rem' }}
                                            onClick={()=>{
                                                setIsLoading(true)
                                                setShowApproveModal(true)
                                                setIsLoading(false)
                                            }}
                                        >
                                            Approve
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            style={{ marginLeft: '2rem' }}
                                            onClick={()=>{
                                                setIsLoading(true)
                                                setShowRejectModal(true)
                                                setIsLoading(false)
                                            }}                                        >
                                            Reject
                                        </button>
                                    </div>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

};

export default ReferralDetails;